// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"194":"7d2d7","884":"1f2e7","886":"37d71"}[chunkId] + ".js";
};